import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule  } from '@angular/common/http';
import {RouterModule} from "@angular/router";
import {LocationStrategy, HashLocationStrategy} from '@angular/common';
import {NgxPaginationModule} from 'ngx-pagination';
import { DatePipe } from '@angular/common';
import { DataTablesModule } from "angular-datatables";
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';

import {ROUTES} from "./app.routes";
import { AppComponent } from './app.component';

// App views
import {AppviewsModule} from "./views/appviews/appviews.module";


// App modules/components
import {LayoutsModule} from "./components/common/layouts/layouts.module";
import { EjemploService } from './services/ejemplo.service';
/* Hormigones*/
import { ServicioService } from "app/services/servicio.services";
import { ReactiveFormsModule } from '@angular/forms';
import { CertificadosComponent } from './certificados/certificados.component';
import {MiCuentaComponent} from './mi-cuenta/mi-cuenta.component';
import {ObrasComponent} from './obras/obras.component';
import { ResultadoComponent } from './resultado/resultado.component';
import { PopupComponent } from './popup/popup.component';
import { CambioPassComponent } from './cambio-pass/cambio-pass.component';
import { NewPasswordComponent } from './new-password/new-password.component';

@NgModule({
  declarations: [
    AppComponent,
    CertificadosComponent,
    MiCuentaComponent,
    ObrasComponent,
    ResultadoComponent,
    PopupComponent,
    CambioPassComponent,
    NewPasswordComponent,

  ],
  imports: [
    NgxPaginationModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    LayoutsModule,
    AppviewsModule,
    RouterModule.forRoot(ROUTES),
    NgxPaginationModule,
    ReactiveFormsModule,
    DataTablesModule,
    RecaptchaModule,
    RecaptchaFormsModule,
  ],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy},EjemploService,DatePipe,ServicioService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts